(() => {
  'use strict';

  const ROOT_SELECTOR = 'wheel-configurator:not([data-aventador])';
  const BUILD_ID = 'SBF-GENERIC-AI-RESULT-20260723-V3-DARK-STUDIO-NO-LOGO';

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getModal(root) {
    return root?._aiModal || root?.querySelector('[data-role="wc-ai-modal"]') || null;
  }

  function getResultImage(root) {
    return getModal(root)?.querySelector('[data-role="ai-result-img"]') || null;
  }

  function setText(modal, role, value) {
    const element = modal?.querySelector(`[data-role="${role}"]`);
    if (element) element.textContent = value;
  }

  function parseProduct(root) {
    const fullTitle = clean(root?.dataset.productTitle || 'Felg');
    const vendor = clean(root?.dataset.productVendor || '');
    const knownFinishes = [
      'Black Gloss Polished', 'Carbon Gloss Dark', 'Carbon Gloss Polished',
      'Gloss Satin Silver', 'Gloss Light Gunmetal', 'Matt Light Gunmetal',
      'Brushed Tinted Black', 'Brushed Titanium', 'Custom Finish',
      'Gloss Black', 'Gloss Bronze', 'Gloss Silver', 'Matt Black',
      'Matt Graphite', 'Matt Bronze', 'Gloss Gold', 'Gloss Red',
      'Gloss White', 'Brushed Bronze', 'Brushed Gold', 'Hyper Black',
      'Gunmetal', 'Silver', 'Bronze', 'Gold', 'White', 'Black'
    ];

    const selectedFinish = clean(root?._selectedFinish);
    const titleFinish = knownFinishes.find(finish =>
      fullTitle.toLowerCase().endsWith(finish.toLowerCase())
    ) || '';
    const finish = selectedFinish || titleFinish || 'Standard finish';

    let model = fullTitle;
    const prefixes = [
      vendor,
      'Japan Racing Wheels',
      'Japan Racing',
      'JR Wheels',
      'Vesser Wheels',
      'Vesser',
      'Concaver Wheels',
      'Concaver'
    ].filter(Boolean);

    for (const prefix of prefixes) {
      const escaped = prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      model = model.replace(new RegExp(`^${escaped}[\\s–—-]*`, 'i'), '').trim();
    }

    if (titleFinish) {
      const escapedFinish = titleFinish.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      model = model.replace(new RegExp(`[\\s–—-]*${escapedFinish}$`, 'i'), '').trim();
    }

    return {
      model: model || fullTitle || 'Felg',
      finish,
    };
  }

  function selectedDiameter(root, modal) {
    const values = [
      root?._aiDesiredDiam,
      root?._selectedDiameter,
      clean(root?._selectedSize).match(/\d{2}/)?.[0]
    ];

    const selectedButton = modal?.querySelector(
      '[data-role="ai-desired-diam-grid"] .wc__btn3d--selected,' +
      '[data-role="ai-desired-diam-grid"] [aria-pressed="true"],' +
      '[data-role="ai-desired-diam-grid"] .is-selected,' +
      '[data-role="ai-desired-diam-grid"] .selected'
    );
    values.push(selectedButton?.dataset?.diam);
    values.push(clean(selectedButton?.textContent).replace(/[^0-9.]/g, ''));

    for (const value of values) {
      const number = Number(value);
      if (Number.isFinite(number) && number > 0) return number;
    }
    return null;
  }

  function updateSummary(root) {
    const modal = getModal(root);
    if (!modal) return;

    const product = parseProduct(root);
    const meta = root._aiResultMeta || window.__SBF_WHEEL_VISUALIZER_META__ || {};
    const diameter = Number(meta.desired_diameter) || selectedDiameter(root, modal);
    const darkStudio = meta.dark_studio == null
      ? Boolean(modal.querySelector('[data-role="ai-dark-studio"]')?.checked)
      : Boolean(meta.dark_studio);

    setText(modal, 'aw-result-model', clean(meta.wheel_model) || product.model);
    setText(modal, 'aw-result-finish', clean(meta.finish_name) || product.finish);
    setText(modal, 'aw-result-size', diameter ? `${diameter}\u2033` : (clean(meta.selected_size) || 'Valgt størrelse'));
    setText(modal, 'aw-result-ride-height', meta.lower_car ? 'Senket' : 'Original');
    setText(modal, 'aw-result-background', darkStudio ? 'Mørkt studio' : 'Original');
    setText(
      modal,
      'aw-result-background-note',
      darkStudio ? 'Premium studiobelysning' : 'Originalt miljø'
    );
  }

  function styleActionIcon(button, width, height) {
    const svg = button?.querySelector(':scope > svg');
    if (!svg) return;
    svg.style.setProperty('display', 'block', 'important');
    svg.style.setProperty('visibility', 'visible', 'important');
    svg.style.setProperty('opacity', '1', 'important');
    svg.style.setProperty('width', `${width}px`, 'important');
    svg.style.setProperty('height', `${height}px`, 'important');
    svg.style.setProperty('min-width', `${width}px`, 'important');
    svg.style.setProperty('flex', `0 0 ${width}px`, 'important');
    svg.style.setProperty('margin-right', '12px', 'important');
    svg.style.setProperty('stroke', '#e5c36c', 'important');
    svg.style.setProperty('fill', 'none', 'important');
  }

  function ensureActions(root) {
    const modal = getModal(root);
    if (!modal) return;
    modal.classList.add('sbf-ai-generic-modal');
    modal.querySelectorAll('.aw-ai-brand, .aw-ai-preview-logo, [data-role="aw-guaranteed-watermark"]').forEach(node => node.remove());

    const download = modal.querySelector('[data-role="aw-download-result"]');
    const again = modal.querySelector('[data-role="aw-create-another"]');
    styleActionIcon(download, 24, 24);
    styleActionIcon(again, 19, 19);

    if (download) {
      download.style.setProperty('display', 'flex', 'important');
      download.style.setProperty('align-items', 'center', 'important');
      download.style.setProperty('justify-content', 'flex-start', 'important');
      download.style.setProperty('text-align', 'left', 'important');
      const small = download.querySelector('small');
      if (small) small.textContent = 'Høyoppløselig bilde uten logo';
    }

    if (again) {
      again.style.setProperty('display', 'flex', 'important');
      again.style.setProperty('align-items', 'center', 'important');
      again.style.setProperty('justify-content', 'center', 'important');
    }
  }

  function installStyles() {
    if (document.getElementById('sbf-generic-ai-result-styles')) return;
    const style = document.createElement('style');
    style.id = 'sbf-generic-ai-result-styles';
    style.textContent = `
      .sbf-ai-generic-modal [data-role="aw-result-card"]::after {
        content: none !important;
        display: none !important;
        background: none !important;
        background-image: none !important;
      }
      .sbf-ai-generic-modal [data-role="aw-download-result"]::before,
      .sbf-ai-generic-modal [data-role="aw-create-another"]::before {
        content: none !important;
        display: none !important;
        background: none !important;
      }
      .sbf-ai-generic-modal [data-role="aw-download-result"] > svg,
      .sbf-ai-generic-modal [data-role="aw-create-another"] > svg {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
      .sbf-ai-generic-modal .aw-ai-setup__item strong,
      .sbf-ai-generic-modal .aw-ai-setup__item em,
      .sbf-ai-generic-modal .aw-ai-setup__item small {
        overflow-wrap: anywhere;
      }
    `;
    document.head.appendChild(style);
  }

  function resultSource(root) {
    const image = getResultImage(root);
    return image?.currentSrc || image?.src || '';
  }

  function safeFilename(root) {
    const product = parseProduct(root);
    const base = clean(product.model || 'felg-visualisering')
      .replace(/[^a-z0-9æøå]+/gi, '-')
      .replace(/^-+|-+$/g, '')
      .toLowerCase();
    return `${base || 'felg-visualisering'}.jpg`;
  }

  function mobileDevice() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  function preopenWindow() {
    const popup = window.open('', '_blank');
    if (!popup) return null;
    popup.document.open();
    popup.document.write('<!doctype html><html><head><meta name="viewport" content="width=device-width,initial-scale=1"><title>Klargjør bilde</title><style>html,body{margin:0;min-height:100%;display:grid;place-items:center;background:#000;color:#fff;font-family:Arial,sans-serif}p{opacity:.75}</style></head><body><p>Klargjør høyoppløselig bilde …</p></body></html>');
    popup.document.close();
    return popup;
  }

  function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject(reader.error || new Error('Kunne ikke lese bildefilen'));
      reader.readAsDataURL(blob);
    });
  }

  async function sourcePayload(src, filename) {
    if (!src) throw new Error('Fant ikke det ferdige bildet');
    const response = await fetch(src, {
      mode: /^(data:|blob:)/i.test(src) ? 'same-origin' : 'cors',
      credentials: 'omit',
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`Bildekilden svarte ${response.status}`);
    const blob = await response.blob();
    const type = blob.type || 'image/jpeg';
    const file = typeof File === 'function'
      ? new File([blob], filename, { type, lastModified: Date.now() })
      : Object.assign(blob, { name: filename, lastModified: Date.now() });
    return { blob, file, dataUrl: await blobToDataUrl(blob), filename };
  }

  function writeMobileImagePage(popup, dataUrl, filename) {
    const target = popup && !popup.closed ? popup : window.open('', '_blank');
    if (!target) return false;
    const safeSrc = String(dataUrl).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    const safeName = String(filename).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    target.document.open();
    target.document.write(`<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1"><title>AI-visualisering</title><style>html,body{margin:0;min-height:100%;background:#000;color:#fff;font-family:Arial,sans-serif}.wrap{min-height:100dvh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:14px;box-sizing:border-box}.note{max-width:520px;text-align:center;font-size:14px;line-height:1.45;color:rgba(255,255,255,.82)}img{display:block;max-width:100%;max-height:82dvh;height:auto;object-fit:contain;border-radius:8px}.btn{display:inline-flex;padding:12px 18px;border:1px solid #d4ad5e;border-radius:999px;color:#fff;text-decoration:none;font-weight:700}</style></head><body><div class="wrap"><div class="note">Hold fingeren på bildet og velg «Lagre i Bilder». Bildet er uten logo.</div><img src="${safeSrc}" alt="AI-visualisert bil"><a class="btn" href="${safeSrc}" download="${safeName}">Last ned bilde</a></div></body></html>`);
    target.document.close();
    return true;
  }

  function triggerDesktopDownload(payload) {
    const url = URL.createObjectURL(payload.blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = payload.filename;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  }

  async function downloadResult(root, popup) {
    const src = resultSource(root);
    const filename = safeFilename(root);
    try {
      const payload = await sourcePayload(src, filename);
      if (mobileDevice()) {
        writeMobileImagePage(popup, payload.dataUrl, payload.filename);
      } else {
        if (popup && !popup.closed) popup.close();
        triggerDesktopDownload(payload);
      }
    } catch (error) {
      console.warn('[SBF AI] Kunne ikke lage lokal bildefil. Åpner originalbildet:', error);
      if (popup && !popup.closed) {
        popup.location.href = src;
      } else if (src) {
        window.open(src, '_blank', 'noopener');
      }
    }
  }

  function resetVisualizer(root) {
    const modal = getModal(root);
    if (!modal) return;

    root._aiResultImage = null;
    root._aiResultUrl = null;
    root._aiCurrentDiam = null;
    root._aiDesiredDiam = null;
    try {
      localStorage.removeItem(`wc_ai_result_${root.dataset.productHandle || ''}`);
    } catch (_err) {}

    modal.querySelector('[data-role="ai-result-img"]')?.removeAttribute('src');
    modal.querySelector('[data-role="ai-result-error"]')?.setAttribute('hidden', '');
    modal.querySelector('[data-role="ai-delete-image"]')?.click();

    if (typeof root._aiSetStep === 'function') {
      root._aiSetStep(1);
    } else {
      modal.querySelectorAll('[data-role^="ai-step-"]').forEach(step => {
        step.hidden = step.dataset.role !== 'ai-step-upload';
      });
    }

    root._aiBtn?.classList.remove('wc__ai-btn--ready');
  }

  function fullscreen(root) {
    const src = resultSource(root);
    if (!src) return;
    document.querySelector('[data-role="sbf-generic-ai-lightbox"]')?.remove();
    const box = document.createElement('div');
    box.dataset.role = 'sbf-generic-ai-lightbox';
    box.innerHTML = '<button type="button" aria-label="Lukk">&times;</button><img alt="AI-visualisert bil">';
    box.querySelector('img').src = src;
    Object.assign(box.style, {
      position: 'fixed', inset: '0', zIndex: '2147483647', background: 'rgba(0,0,0,.96)',
      display: 'grid', placeItems: 'center', padding: '12px'
    });
    const image = box.querySelector('img');
    Object.assign(image.style, { maxWidth: '100%', maxHeight: '92dvh', objectFit: 'contain' });
    const close = box.querySelector('button');
    Object.assign(close.style, {
      position: 'fixed', top: '14px', right: '14px', width: '44px', height: '44px',
      borderRadius: '50%', border: '1px solid #d4ad5e', background: '#080808',
      color: '#d4ad5e', fontSize: '30px', lineHeight: '1', zIndex: '2'
    });
    const remove = () => box.remove();
    close.addEventListener('click', remove);
    box.addEventListener('click', event => { if (event.target === box) remove(); });
    document.body.appendChild(box);
  }

  function bindRoot(root) {
    if (!root || root.dataset.sbfGenericAiResultBound === '1') return;
    const modal = getModal(root);
    if (!modal) return;

    root.dataset.sbfGenericAiResultBound = '1';
    modal.dataset.sbfGenericAiBuild = BUILD_ID;
    installStyles();
    ensureActions(root);
    updateSummary(root);

    root.addEventListener('wheel-configurator:ai-meta', () => updateSummary(root));

    modal.addEventListener('change', event => {
      if (event.target.matches('[data-role="ai-dark-studio"]')) updateSummary(root);
    });

    modal.addEventListener('click', event => {
      const download = event.target.closest('[data-role="aw-download-result"]');
      if (download) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (download.dataset.loading === '1') return;
        const popup = mobileDevice() ? preopenWindow() : null;
        download.dataset.loading = '1';
        download.disabled = true;
        downloadResult(root, popup).finally(() => {
          download.disabled = false;
          delete download.dataset.loading;
        });
        return;
      }

      if (event.target.closest('[data-role="aw-create-another"]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        resetVisualizer(root);
        return;
      }

      if (event.target.closest('[data-role="aw-result-fullscreen"]')) {
        event.preventDefault();
        fullscreen(root);
      }
    }, true);

    const resultImage = getResultImage(root);
    if (resultImage) {
      const sync = () => {
        ensureActions(root);
        updateSummary(root);
      };
      resultImage.addEventListener('load', sync);
      new MutationObserver(sync).observe(resultImage, {
        attributes: true,
        attributeFilter: ['src'],
      });
    }

    const resultStep = modal.querySelector('[data-role="ai-step-result"]');
    if (resultStep) {
      new MutationObserver(() => {
        if (!resultStep.hidden) {
          ensureActions(root);
          updateSummary(root);
        }
      }).observe(resultStep, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.setTimeout(init, 300);
  window.setTimeout(init, 1000);
})();
